export const MONITORING_FEED_COPY = {
	title: {
		add: 'Add monitoring feed',
		edit: 'Edit monitoring feed',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Capture the newsletters, portals, and tools that trigger regulatory updates.',
	fields: {
		sourceLabel: 'Which monitoring feed or tool do you track?',
		frequencyLabel: 'How often do you review this feed?',
		detailLabel: 'Which feed or link should we cite? (optional)',
		detailDescription:
			'Example: “FDA Cosmetics Supervision newsletter” or a direct URL.',
	},
	actions: {
		removeConfirmTitle: 'Remove this monitoring feed?',
		removeConfirmDescription:
			'This feed will be removed from the plan. You can add it again later.',
	},
	summary: {
		detailMissing: 'Details missing.',
	},
}
